import { Injectable } from '@angular/core';
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { filter, map, switchMap } from 'rxjs/operators';
import {  ROLE_AGENTE_CONSULTA, ROLE_GERENCIAR_AGENTES_FINANCEIROS
         ,ROLE_GERENCIAR_USUARIOS, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO
         ,ROLE_CONSULTA_SCR,
         ROLE_COTISTA_CONSULTA,
         ROLE_DEPR_CONSULTA,
         ROLE_GESTOR_AVALIADOR_FGE} from './constantes/permissao.constants';
import { FeaturesService } from './features/features.service';
import { PermissaoService } from './shared/permissao.service';
import { ModalidadeService } from './shared/services/modalidade.service';
import { AmbienteService } from 'src/app/shared/services/ambiente-service';

// Serviço utilizado para montar os menus com base em permissões e features habilitadas
@Injectable({
    providedIn: 'root'
})
export class MenuService {

    itensMenu$ = this.usuarioService.usuario$.pipe(
        filter(usuario => usuario != null),
        switchMap(() => this.permissaoService.getPermissoesUsuarioAutenticado()),
        switchMap(permissoes => {
            return this.modalidadeService.modalidade$.pipe(
                switchMap(modalidade => {
                    return this.featuresService.getFeaturesAmbiente().pipe(
                        map(features => this.carregaItensMenu(modalidade, features, permissoes))
                    );
                })
            );
        })
    );

    constructor(private usuarioService: BnUsuarioService,
        private permissaoService: PermissaoService,
        private modalidadeService: ModalidadeService,
        private featuresService: FeaturesService,
        private ambienteService: AmbienteService) {
    }

    private carregaItensMenu(modalidade, features, permissoes) {
        let itensMenu = this.obterMenusIniciais();
        return this.filtrarItensPorPermissaoEFeatures(itensMenu, permissoes, features, modalidade);
    }

    private filtrarItensPorPermissaoEFeatures(itensMenu: any[], permissoes, features, modalidade) {
        if (!itensMenu) {
            return itensMenu;
        }

        return itensMenu
            .filter(item => this.verificaPermissoes(item.permissoes, permissoes))
            .filter(item => this.verificaFeatureHabilitada(item.features, features))
            .filter(item =>this.verificaModalidade(item.modalidade, modalidade))
            .map(item => this.aplicarTemplates(item, modalidade))
            .map(item => {
                item.subitem = this.filtrarItensPorPermissaoEFeatures(item.subitem, permissoes, features, modalidade);
                return item;
            });
    }

    private verificaModalidade(modalidadeItem: string, modalidadeAtual: string): boolean{
        if(!modalidadeItem){
            return true;
        }

        return modalidadeItem === modalidadeAtual;
    }

    private aplicarTemplates(item, modalidade) {
        if (item.urlTemplate) {
            item.url = item.urlTemplate(modalidade);
        }

        return item;
    }

    private verificaPermissoes(permissoesItem: any[], permissoesUsuario) {
        if (!permissoesItem) {
            return true;
        }

        if (!permissoesUsuario) {
            return false;
        }

        return permissoesItem.some(p => permissoesUsuario[p]);
    }

    private verificaFeatureHabilitada(featureItem, features) {
        if (!featureItem) {
            return true;
        }

        if (!features) {
            return false;
        }

        return featureItem.some(f => features[f] === 'S' || features[f] === 'true');
    }

    private obterMenusIniciais() {
        // preencher as propriedades permissoes e feature nos itens abaixo
        return [
            {
                id: 'Home',
                titulo: 'Início',
                classeIcone: 'fa-home',
                url: 'home',
            },
            {
                titulo: 'Avisos',
                classeIcone: 'fa fa-sticky-note-o',
                subitem: [
                    {
                        titulo: 'Avisos',
                        classeIcone: 'fa-sticky-note-o',
                        url: 'avisos/pesquisa',
                    },
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
            },
            {
                titulo: 'Empresas bloqueadas',
                classeIcone: 'fa fa-file-excel-o',
                subitem: [
                    {
                        titulo: 'Envio/consulta de arquivos',
                        classeIcone: 'fa fa-file',
                        url: 'empresas-bloqueadas/envio-consulta',
                    },
                    {
                        titulo: 'Empresas bloqueadas',
                        classeIcone: 'fa fa-file-excel-o',
                        url: 'empresas-bloqueadas',
                    },
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                features: ['empresasBloqueadas'],
            },
            {
                titulo: 'Contratação',
                classeIcone: 'fa-file-signature',
                subitem: [
                    {
                        titulo: 'Envio/consulta de arquivos',
                        classeIcone: 'fa-file-o',
                        url: 'operacoes/lote',
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                    },
                    {
                        titulo: 'Envio/consulta IPD',
                        classeIcone: 'fa-file-o',
                        url: 'operacoes/ipd',
                        modalidade:'FGBS',
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                    },
                    {
                        titulo: 'Envio/consulta IPD',
                        classeIcone: 'fa-file-o',
                        url: 'operacoes/ipd',
                        modalidade:'FGT',
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                    },

                    {
                        titulo: 'Operações',
                        classeIcone: 'fa-dot-circle-o',
                        url: 'operacoes/pesquisa',
                    },
                    {
                        titulo: 'Envio de operação de Repasse',
                        classeIcone: 'fal fa-file-import',
                        url: 'operacao-repasse/cadastro',
                        features: ['envioOperacaoRepassePorTela'],
                        permissoes: [ROLE_GESTOR_CONSULTA],
                    },
                    {
                        titulo: 'Cálculo do Encargo de Concessão de Garantia',
                        classeIcone: 'fa fa-calculator',
                        url: 'calculo-encargo-concessao-garantia',
                        features: ['calculadoraEcg'],
                        permissoes: [ROLE_GESTOR_CONSULTA],

                    },
                  {
                    titulo: 'Consulta Impedimentos',
                    classeIcone: 'fal fa-search',
                    url: 'consultacadin',
                    permissoes: [ROLE_GESTOR_CONSULTA],
                  },
                    {
                        titulo: 'Cálculo do Saldo Devedor',
                        classeIcone: 'fa fa-calculator',
                        url: 'calculo-saldo-devedor',
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO],
                    },
                    {
                        titulo: 'Cancelamento de garantia ou cobrança de indenização',
                        classeIcone: 'fas fa-ban',
                        url: 'cancelamento/',
                    },
                    {
                        titulo: 'Limite',
                        classeIcone: 'far fa-chart-bar',
                        url: 'limite/pesquisa',
                        features: ['limiteAportadoCesta'],
                    },
                    {
                        titulo: 'Limite',
                        classeIcone: 'far fa-chart-bar',
                        subitem: [
                            {
                                titulo: 'Limite de aporte',
                                classeIcone: 'far fa-chart-bar',
                                url: 'limite-contratacao/pesquisa',
                                features: ['limiteAportado'],
                            },
                            {
                                titulo: 'Limite de exposição',
                                classeIcone: 'fa-solid fa-calculator',
                                url: 'limite-exposicao/pesquisa',
                                features: ['limiteAportadoExposicao'],
                            },
                        ],
                        features: ['limiteAportado'],
                    },
                    {
                        titulo: 'Limite',
                        classeIcone: 'far fa-chart-bar',
                        subitem: [
                            {
                                titulo: 'Limite de contratação',
                                classeIcone: 'far fa-chart-bar',
                                url: 'limite/pesquisa',
                                features: ['limiteContratacao'],
                            },
                            {
                                titulo: 'Limite de exposição',
                                classeIcone: 'fa-solid fa-calculator',
                                url: 'limite-exposicao/pesquisa',
                                features: ['limiteContratacao'],
                            },
                        ],
                        features: ['limiteContratacao'],
                    },
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
            },
            {
                titulo: 'Limites',
                classeIcone: 'far fa-chart-bar',
                subitem: [
                    {
                        titulo: 'Limite de contratação',
                        classeIcone: 'far fa-chart-bar',
                        url: 'limite/pesquisa',
                        features: ['limiteContratacao']
                    },
                    {
                        titulo: 'Limite de exposição',
                        classeIcone: 'fa-solid fa-calculator',
                        url: 'limite-exposicao/pesquisa',
                        features: ['limiteContratacao']
                    },
                ],
                features: ['limiteContratacao'],
                permissoes: [ROLE_COTISTA_CONSULTA],
            },
            {
                titulo: 'Taxas de juros',
                classeIcone: 'fa-wave-square',
                subitem: [
                    {
                        titulo:'Janelas de apuração',
                        classeIcone: 'fa-window-maximize',
                        url:'janelas-apuracao/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA],
                    },
                    {
                        titulo: 'Taxa de juros equivalente',
                        classeIcone: 'fa-percent',
                        url: 'taxa-juros-equivalente/listagem'
                    },
                    {
                        titulo: 'Taxa de juros máxima',
                        classeIcone: 'fa-exclamation',
                        url: 'taxa-juros-maxima-agente/listagem'
                    },
                    {
                        titulo: 'Taxa de juros média',
                        classeIcone: 'fa-tachometer',
                        url: 'taxa-juros-media-agente/pesquisa'
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                features: ['taxas']
            },
            {
                titulo: 'Honra',
                classeIcone: 'fas fa-hand-holding-usd',
                subitem: [
                    {
                        titulo: 'Envio/consulta de arquivos',
                        classeIcone: 'fa-file-o',
                        url: 'solicitacoes-honra/lote',
                    },
                    {
                        titulo: 'Solicitações de honra',
                        classeIcone: 'fas fa-hand-holding-usd',
                        url: 'solicitacoes-honra/pesquisa',
                    },
                    {
                        titulo: 'Janelas de solicitações de honra',
                        classeIcone: 'fa fa-window-maximize',
                        url: 'solicitacoes-honra/janelas/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                        titulo: 'Validações SCR',
                        classeIcone: 'fas fa-clipboard-check',
                        url: 'validacoes-scr/pesquisa',
                        features: ['scr'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                    },
                    {
                        titulo: 'Limite de Honra',
                        classeIcone: 'far fa-chart-bar',
                        url: 'limite-honra/pesquisa',
                    },
                    {
                        titulo: 'Consulta de IPOC',
                        classeIcone: 'fa-file-o',
                        url: 'consulta-ipoc/pesquisa',
                        features: ['scr'],
                        permissoes: [ROLE_CONSULTA_SCR, ROLE_AGENTE_CONSULTA]
                    },
                    {
                        titulo: 'Acompanhamento de rotinas batch',
                        classeIcone: 'fa-cogs',
                        url: 'acompanhamento-batch/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                features: ['honra']
            },
            {
                titulo: 'Renúncia',
                classeIcone: 'fas fa-warning',
                subitem: [
                    {
                        titulo: 'Renúncia à Cobertura Máxima de Inadimplência',
                        classeIcone: 'fas fa-warning',
                        subitem: [
                            {
                                titulo: 'Consulta de Protocolo',
                                classeIcone: 'fa-file-o',
                                url: 'renuncia/consulta-protocolo',
                                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                            },
                            {
                                titulo: 'Solicitação de Renúncia',
                                classeIcone: 'fas fa-hand-holding-usd',
                                url: 'renuncia/pesquisa',
                                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                            }
                        ],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                        features: ['renunciaCoberturaMaximaInadimplencia'],
                    },
                    {
                        titulo: 'Renúncia Limite Adicional',
                        classeIcone: 'fas fa-file-o',
                        subitem: [
                            {
                                titulo: 'Solicitação de Renúncia',
                                classeIcone: 'fas fa-hand-holding-usd',
                                url: 'renuncia-limite-adicional/pesquisa',
                                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                            }
                        ],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                    },
                    {
                        titulo: 'Tarefas',
                        classeIcone: 'fas fa-tasks',
                        url: 'renuncia/tarefas',
                        permissoes: [ROLE_GESTOR_ENVIO, ROLE_GESTOR_CONSULTA]
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
            },
            {
                titulo: 'Recuperação de crédito',
                classeIcone: 'fas fa-comments-dollar',
                subitem: [
                    {
                        titulo: 'Envio/consulta de arquivos',
                        classeIcone: 'fa-file-o',
                        url: 'recuperacoes-credito/lote',
                    },
                    {
                        titulo: 'Recuperações de crédito',
                        classeIcone: 'fas fa-comments-dollar',
                        url: 'recuperacoes-credito/pesquisa',
                    },
                    {
                        titulo: 'Recuperações inconsistentes',
                        classeIcone: 'fas fa-exclamation',
                        url: 'recuperacoes-credito/recuperacoes-inconsistentes',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                        titulo: 'Devoluções de valor honrado a recuperar',
                        classeIcone: 'fas fa-retweet',
                        url: 'devolucao/pesquisa'
                    },
                    {
                        titulo: 'Cálculo do valor honrado a recuperar',
                        classeIcone: 'fas fa-calculator',
                        url: 'recuperacoes-credito/calculo-valor-honrado-recuperar',
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                features: ['recuperacao'],
            },
            {
                titulo: 'Leilão',
                classeIcone: 'fas fa-money-bill-wave',
                subitem: [
                    {
                        titulo: 'Envio/consulta de arquivos',
                        classeIcone: 'fa-file-o',
                        url: 'leilao/pesquisa',
                    },
                    {
                        titulo: 'Leilões',
                        classeIcone: 'fas fa-comments-dollar',
                        url: 'leilao/leiloes',
                    },
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                features: ['leilao'],
            },
            {
                titulo: 'Prestação de informações',
                classeIcone: 'fas fa-file-import',
                subitem: [
                    {
                        titulo: 'Consulta de arquivos',
                        classeIcone: 'fa-file-o',
                        url: 'atualizacao-informacoes/lote',
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                    },
                    {
                        titulo: 'Informações de risco',
                        classeIcone: 'fas fa-database',
                        url: 'atualizacao-info-risco/',
                        features: ['atualizacaoInfoRisco'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                    },
                    {
                        titulo: 'Posição da carteira em recuperação de crédito',
                        classeIcone: 'fas fa-balance-scale',
                        url: 'acompanhamento-processual/',
                        features: ['acompanhamentoProcessual'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                    },
                    {
                        titulo: 'Janelas',
                        classeIcone: 'fas fa-calendar-alt',
                        url: 'janelas-atualizacao-info/pesquisa',
                        features: ['janelaAtualizacaoInformacoes'],
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                        titulo: 'Acompanhamento',
                        classeIcone: 'fas fa-angle-double-left',
                        features: ['acompanhamentoDocumentoDepr'],
                        subitem: [
                            {
                                titulo: 'Envio/consulta de documentos',
                                classeIcone: 'fas fa-file-import',
                                url: 'acompanhamento-documento-depr/',
                            }
                        ],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA, ROLE_DEPR_CONSULTA]
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA, ROLE_DEPR_CONSULTA],
                features: ['acompanhamentoProcessual', 'atualizacaoInfoRisco'],
            },
            {
                titulo: 'Cobrança',
                classeIcone: 'fa fa-money',
                subitem: [
                    {
                        titulo: 'Boletos de cobrança',
                        classeIcone: 'fa-file-invoice-dollar',
                        url: 'cobrancas/pesquisa',
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
            },
            {
                titulo: 'Exportação',
                classeIcone: 'fa-file-export',
                subitem: [
                    {
                        titulo: 'Operações',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/operacoes`
                    },
                    {
                        titulo: 'Amortizações Crédito Livre',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/amortizacoes`,
                    },
                    {
                        titulo: 'Aditivos',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/aditivos`,
                    },
                    {
                        titulo: 'Solicitações de honra',
                        classeIcone: 'fa-file-export',
                        url: 'exportacao/solicitacoes-honra-exportacao',
                        features: ['solicitacoesHonraExportacao']
                    },
                    {
                        titulo: 'Recuperações de crédito',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/recuperacoes-credito`,
                    },
                    {
                        titulo: 'Devoluções de valor honrado a recuperar',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/devolucoes`,
                    },
                    {
                        titulo: 'Operações elegíveis a leilão',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/operacoes-elegiveis-leilao`,
                        features: ['leilao']
                    },
                    {
                        titulo: 'Solicitações de cancelamento',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/solicitacoes-cancelamento`,
                    },
                    {
                        titulo: 'Posição da carteira em recuperação de crédito',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/acompanhamentos-processuais`,
                        features: ['acompanhamentoProcessual']
                    },
                    {
                        titulo: 'Validações SCR',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/validacoes-scr`,
                        features: ['scr']
                    },
                    {
                        titulo: 'Empresas bloqueadas',
                        classeIcone: 'fa-file-excel',
                        url: 'exportacao/empresas-bloqueadas',
                        features: ['empresasBloqueadasExportacao']
                    },
                    {
                        titulo: 'IPOCs sem dados SCR',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/ipocs-sem-dados-scr`,
                        features: ['scr']
                    },
                    {
                        titulo: 'IPOCs Operações Garantidas',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/ipocs-operacoes-garantidas`,
                        features: ['scr']
                    },
                    {
                        titulo: 'Acompanhamento de metas de distribuição de limites',
                        classeIcone: 'fa-list-alt',
                        url: 'exportacao-agente-financeiro/acomp-metas-distribuicao-limites-gestor',
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_COTISTA_CONSULTA]
                    },
                    {
                        titulo: 'Apuração de taxas médias por operação',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-gestor/taxas-medias-agentes-por-operacao`,
                        features: ['taxas']
                    }
                ],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_COTISTA_CONSULTA],
            },
            {
                titulo: 'Exportação',
                classeIcone: 'fa-file-export',
                subitem: [
                    {
                        titulo: 'Operações',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/operacoes`
                    },
                    {
                        titulo: 'Amortizações Crédito Livre',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/amortizacoes`,
                    },
                    {
                        titulo: 'Aditivos',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/aditivos`,
                    },
                    {
                        titulo: 'Solicitações de honra',
                        classeIcone: 'fa-file-export',
                        url: 'exportacao/solicitacoes-honra-exportacao',
                        features: ['solicitacoesHonraExportacao']
                    },
                    ,
                    {
                        titulo: 'Extratos pagto. honra - Credt. Livre',
                        classeIcone: 'fa-file-csv',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/extrato-honra/credito-livre`
                    },
                    {
                        titulo: 'Extratos pagto. honra - Repasse',
                        classeIcone: 'fa-file-csv',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/extrato-honra/repasse`
                    },
                    {
                        titulo: 'Recuperações de crédito',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/recuperacoes-credito`,
                    },
                    {
                        titulo: 'Devoluções de valor honrado a recuperar',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/devolucoes`,
                    },
                    {
                        titulo: 'Operações elegíveis a leilão',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/operacoes-elegiveis-leilao`,
                        features: ['leilao']
                    },
                    {
                        titulo: 'Solicitações de cancelamento',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/solicitacoes-cancelamento`,
                    },
                    {
                        titulo: 'Empresas bloqueadas',
                        classeIcone: 'fa-file-excel',
                        url: 'exportacao/empresas-bloqueadas',
                        features: ['solicitacaoArquivoEmpresasBloqueadas']
                    },
                    {
                        titulo: 'IPOCs sem dados SCR',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/ipocs-sem-dados-scr`,
                        features: ['scr']
                    },
                    {
                        titulo: 'IPOCs Operações Garantidas',
                        classeIcone: 'fa-file-excel',
                        urlTemplate: (modalidade) => `/fg2/rest/front/${modalidade}/exportacao-agente-financeiro/ipocs-operacoes-garantidas`,
                        features: ['scr']
                    },
                    {
                        titulo: 'Acompanhamento de metas de distribuição de limites',
                        classeIcone: 'fa-list-alt',
                        url: 'exportacao-agente-financeiro/acomp-metas-distribuicao-limites',
                    }
                ],
                permissoes: [ROLE_AGENTE_CONSULTA],
            },
            {
                titulo: 'SCR',
                classeIcone: 'fa-satellite-dish',
                subitem: [
                    {
                        titulo: 'Importar',
                        classeIcone: 'fa-file-import',
                        url: 'integracao/scr/importacao',
                        permissoes: [ROLE_GESTOR_ENVIO]
                    },
                    {
                        titulo: 'Consultar',
                        classeIcone: 'fas fa-search',
                        url: 'integracao/scr/pesquisa',
                        permissoes: [ROLE_GESTOR_ENVIO]
                    },
                    {
                        titulo: 'Associados',
                        classeIcone: 'far fa-handshake',
                        url: 'integracao/scr/associados',
                        permissoes: [ROLE_GESTOR_ENVIO]
                    },
                    // {
                    //     titulo: 'Controle',
                    //     classeIcone: 'fas fa-tasks',
                    //     url: 'integracao/scr/controle',
                    //     permissoes: [ROLE_GESTOR_ENVIO]
                    // },
                    {
                        titulo: 'Ocorrências SCR (IPOC)',
                        classeIcone: 'fas fa-key',
                        url: 'integracao/scr/ipoc'
                        //permissoes: as permissões herdadas (ROLE_CONSULTA_SCR, ROLE_AGENTE_CONSULTA) são suficientes
                    },
                    {
                        titulo: 'Consulta de IPOC',
                        classeIcone: 'fa-file-o',
                        url: 'consulta-ipoc/pesquisa',
                        features: ['scr'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA]
                    }
                ],
                permissoes: [ROLE_CONSULTA_SCR, ROLE_AGENTE_CONSULTA],
                features: ['scr'],
            },
            {
                titulo: 'Gestão de usuários',
                classeIcone: 'fa-cog',
                subitem: [
                    {
                        titulo: 'Usuários',
                        classeIcone: 'fa-user-circle-o',
                        url: 'admin/usuarios',
                        permissoes: [ROLE_GERENCIAR_USUARIOS]
                    },
                    {
                        titulo: 'Agentes financeiros',
                        classeIcone: 'fa-building-o',
                        url: 'admin/agentes-financeiros',
                        permissoes: [ROLE_GERENCIAR_AGENTES_FINANCEIROS],
                    }
                ],
                permissoes: [ROLE_GERENCIAR_USUARIOS, ROLE_GERENCIAR_AGENTES_FINANCEIROS],
            },
            {
              titulo: 'Tarefas',
              classeIcone: 'fas fa-tasks',
              subitem: [
                {
                  titulo: 'Sistema',
                  classeIcone: 'fas fa-calendar-alt',
                  url: 'tarefas/sistema',
                  features: ['tarefasSistema']
                 },
                {
                  titulo: 'Protocolo',
                  classeIcone: 'fas fa-clipboard',
                  url: 'tarefas/protocolo',
                  permissoes: [ROLE_GESTOR_ENVIO]
                 },
                 {
                    titulo: 'Limite',
                    classeIcone: 'far fa-chart-bar',
                    url: 'tarefas/limites',
                    features: ['tarefasLimite']
                  },
                  {
                    titulo: 'Inadimplência',
                    classeIcone: 'fa-solid fa-skull-crossbones',
                    url: 'tarefas/inadimplencia',
                    features: ['tarefasInadimplencia']
                  },
                  {
                  titulo: 'Operação',
                  classeIcone: 'fa fa-download',
                  url: 'tarefas/operacao',
                  features: ['tarefasOperacao']
                  },
                  {
                  titulo: 'Relatórios',
                  classeIcone: 'far fa-clipboard',
                  url: 'tarefas/relatorios',
                  features: ['tarefasRelatorios', 'tarefasRelatoriosValorNaoComprometido']
                  },
                  {
                    titulo: 'Honra',
                    classeIcone: 'fas fa-hand-holding-usd',
                    url: 'tarefas/honra',
                    features: ['tarefasHonra']
                  },
                  {
                    titulo: 'Recuperação de crédito',
                    classeIcone: 'fas fa-comments-dollar',
                    url: 'tarefas/recuperacao-de-credito',
                    features: ['tarefasRecuperacao']
                  },
                  {
                    titulo: 'Leilão',
                    classeIcone: 'fas fa-money-bill-wave',
                    url: 'tarefas/leilao',
                    features: ['tarefasLeilao']
                  },
                  {
                    titulo: 'Remuneração',
                    classeIcone: 'fas fa-money',
                    url: 'tarefas/remuneracao',
                    features: ['tarefasRemuneracao'],
                    permissoes: [ROLE_GESTOR_CONSULTA]
                  },
                  {
                    titulo: 'Cobrança',
                    classeIcone: 'fas fa-hand-holding-usd',
                    url: 'tarefas/cobranca',
                    features: ['tarefasCobranca']
                  },
                  {
                    titulo: 'Contrato SCC',
                    classeIcone: 'fas fa-comments-dollar',
                    url: 'tarefas/contrato-scc',
                    features: ['tarefasContratoScc']
                  },
                  {
                    titulo: 'FGEnergia',
                    classeIcone: 'fas fa-tasks',
                    url: 'tarefas/fgenergia',
                    features: ['tarefasQuestionarioFge']
                }
              ],
              permissoes: [ROLE_GESTOR_CONSULTA],
            },
            {
                titulo: 'Questionários FGEnergia',
                classeIcone: 'fas fa-tasks',
                url: 'questionario-fgenergia/pesquisa',
                features: ['questionarioHabilitado'],
                permissoes: [ROLE_GESTOR_CONSULTA, ROLE_GESTOR_AVALIADOR_FGE],
            },
            {
                titulo: 'Gestão do administrador',
                classeIcone: 'fa-cog',
                subitem: [
                    {
                        titulo: 'Modalidade de Garantia',
                        classeIcone: 'fa-file-o',
                        url: 'modalidade-garantia',
                    },
                    {
                      titulo: 'Configurações Cestas',
                      classeIcone: 'fas fa-database',
                      subitem: [
                        {
                            titulo: 'Cestas',
                            classeIcone: 'fas fa-database',
                            url: 'tranches/listagem',
                        },
                        {
                            titulo: 'CNAEs Impedidos',
                            classeIcone: 'fa-solid fa-ban',
                            url: 'cnae-impedido/pesquisa',
                            permissoes: [ROLE_GESTOR_CONSULTA]
                        },
                        {
                            titulo: 'CNAEs Permitidos Grandes Empresas',
                            classeIcone: 'fa-solid fa-check',
                            url: 'cnaes-permitidos',
                            permissoes: [ROLE_GESTOR_CONSULTA]
                        },
                        {
                            titulo: 'Programas Permitidos - Operações de Repasse',
                            classeIcone: 'fa-thumbs-o-up',
                            url: 'programas-permitidos-por-cestas',
                            permissoes: [ROLE_GESTOR_CONSULTA]
                        },
                        {
                            titulo: 'Naturezas Jurídicas Aceitas',
                            classeIcone: 'fa-thumbs-o-up',
                            url: 'consulta-de-naturezas-juridicas-aceitas/pesquisa',
                            permissoes: [ROLE_GESTOR_CONSULTA]
                        },
                        {
                            titulo: 'Limite Adicional',
                            classeIcone: 'fa-bar-chart',
                            url: 'limite-adicional/pesquisa',
                            permissoes: [ROLE_GESTOR_CONSULTA]
                        },

                      ]

                    },
                    {
                      titulo: 'Limite ECG por Terceiros',
                      classeIcone: 'fa-file-o',
                      url: 'limite-pagamento-ecg-por-terceiros',
                      features: ['limitePagamentoEcgTerceiros']
                    },
                    {
                      titulo: 'ECG Por Terceiros',
                      classeIcone: 'fa-bank',
                      url: 'ecg-por-terceiros',
                      features: ['limitePagamentoEcgTerceiros']
                    },
                    {
                      titulo: 'Consulta Pessoa Jurídica',
                      classeIcone: 'fa-file-o',
                      url: 'pessoas-juridicas/listagem',
                      features: ['consultaPessoasJuridicas'],
                    },
                    {
                        titulo: 'Notas',
                        classeIcone: 'far fa-clipboard',
                        url: 'notas/pesquisa',
                    },
                    {
                        titulo: 'Irregularidade de Operação',
                        classeIcone: 'fa-thumbs-o-down',
                        url: 'irregularidade/pesquisa'
                    },
                    {
                        titulo: 'Inadimplementos Operacionais',
                        classeIcone: 'fa fa-bell-o',
                        url: 'inadimplencia/pesquisa'
                    },
                    {
                        titulo: 'Irregularidade de Empresas',
                        classeIcone: 'fa-thumbs-o-down',
                        url: 'irregularidade-empresa/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                        titulo: 'Indexadores',
                        classeIcone: 'fa-calculator',
                        url: 'indexadores/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                      titulo: 'Solicitação de Arquivos',
                      classeIcone: 'fa-solid fa-file',
                      url: 'solicitacao-arquivo/pesquisa',
                      permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                      titulo: 'Faixas de carteira PJ',
                      classeIcone: 'far fa-chart-bar',
                      url: 'faixa-carteira-pessoa-juridica/pesquisa',
                      features: ['faixaCarteira'],
                      permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                      titulo: 'Distribuição de limites',
                      permissoes: [ROLE_GESTOR_CONSULTA],
                      subitem: [
                        {
                            titulo: 'Tarefas',
                            classeIcone: 'fa fa-download',
                            url: 'distribuicao-limites',
                            features: ['distribuicaoLimites'],
                            permissoes: [ROLE_GESTOR_CONSULTA],
                        },
                        {
                            titulo: 'Configurações',
                            classeIcone: 'fa fa-cog',
                            url: 'distribuicao-limites-configuracao',
                            features: ['distribuicaoLimites'],
                            permissoes: [ROLE_GESTOR_CONSULTA],
                        }
                      ]
                    },
                    {
                        titulo: 'Portes de Beneficiário',
                        classeIcone: 'fas fa-search',
                        url: 'porte-beneficiario/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                        titulo: 'Produtos permitidos - Operações de Repasse',
                        classeIcone: 'fa-thumbs-o-up',
                        url: 'produtos-permitidos/pesquisa',
                        permissoes: [ROLE_GESTOR_CONSULTA]
                    },
                    {
                      titulo: 'Modalidade no SCR',
                      classeIcone: 'fa-satellite-dish',
                      url: 'modalidade-scr',
                      permissoes: [ROLE_GESTOR_CONSULTA],
                      features: ['scr']
                    },
                    {
                        titulo: 'Parametrização Impedimento (Cadin)',
                        classeIcone: 'fa-file-o',
                        url: 'parametrizacao/limite-cadin',
                        permissoes: [ROLE_GESTOR_CONSULTA],
                        modalidade:'FGBS'
                    },
                ],
                permissoes: [ROLE_GESTOR_CONSULTA],
            },
            {
                titulo: 'Aportes e Resgates',
                classeIcone: 'fas fa-table',
                features: ['aportesEResgates'],
                subitem: [
                    {
                        titulo: 'Subscrição de cotas',
                        classeIcone: 'fas fa-table',
                        url: 'habilitacao/subscricao',
                        features: ['subscricaoCota'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                    },
                    {
                        titulo: 'Conglomerado',
                        classeIcone: 'fas fa-university',
                        url: 'habilitacao/conglomerado',
                        features: ['conglomerado'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                    },
                    {
                        titulo: 'Habilitação Alternativa',
                        classeIcone: 'fas fa-clipboard-check',
                        url: 'habilitacao/alternativa',
                        features: ['habilitacaoAlternativa'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_AGENTE_CONSULTA],
                    },
                    {
                        titulo: 'Patrimônio Líquido do Fundo',
                        classeIcone: 'fas fa-file-invoice-dollar',
                        url: 'habilitacao/patrimonio-liquido',
                        features: ['patrimonioLiquido'],
                        permissoes: [ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO],
                    },
                ],
              },
              {
                id: 'Termo',
                titulo: 'Termos de uso e política de privacidade',
                classeIcone: 'fa-bank',
                url: 'termo',
            }
        ];
    }
}
